import { useRouteError, isRouteErrorResponse, Link } from 'react-router-dom';
import { paths } from '../../routes/paths';

const RouteErrorBoundary = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <div className="flex h-screen flex-col items-center justify-center bg-background">
        <h1 className="text-[8rem] font-extrabold text-primary leading-none">
          {error.status}
        </h1>
        <p className="text-xl mb-4 text-greyDark">{error.statusText}</p>
        {error.data?.message && (
          <p className="text-sm text-greyModerate mb-8">{error.data.message}</p>
        )}
        <Link
          to={paths.home}
          className="text-white bg-primary hover:bg-primary-800 px-5 py-2 rounded transition-colors"
        >
          Go to Home
        </Link>
      </div>
    );
  }

  // For unexpected errors
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-background">
      <h1 className="text-2xl font-bold text-blackDark mb-2">
        Something went wrong
      </h1>
      <p className="text-greyDark mb-8">
        An unexpected error occurred. Please try again later.
      </p>
      <Link
        to={paths.home}
        className="text-white bg-primary hover:bg-primary-800 px-5 py-2 rounded transition-colors"
      >
        Go to Home
      </Link>
    </div>
  );
};

export default RouteErrorBoundary;
